import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { AlertTriangle } from 'lucide-react';

const ConfirmDeleteDialog = ({ 
  open, 
  onOpenChange, 
  onConfirm, 
  title = "Conferma Eliminazione",
  description = "Questa azione è irreversibile.",
  itemName = "",
  loading = false 
}) => {
  const [inputValue, setInputValue] = useState('');
  const confirmWord = "ELIMINA";

  const handleConfirm = () => {
    if (inputValue === confirmWord) {
      onConfirm();
      setInputValue('');
    }
  };

  const handleOpenChange = (newOpen) => {
    if (!newOpen) {
      setInputValue('');
    }
    onOpenChange(newOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 rounded-full bg-red-100">
              <AlertTriangle className="h-6 w-6 text-red-600" />
            </div>
            <DialogTitle className="text-xl">{title}</DialogTitle>
          </div>
          <DialogDescription className="text-slate-600">
            {description}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 pt-2">
          {itemName && (
            <div className="p-3 bg-slate-50 rounded-lg">
              <p className="text-sm text-slate-500">Elemento da eliminare:</p>
              <p className="font-medium text-slate-900">{itemName}</p>
            </div>
          )}
          
          <div>
            <p className="text-sm text-slate-600 mb-2">
              Per confermare, digita <span className="font-bold text-red-600">{confirmWord}</span> nel campo sottostante:
            </p>
            <Input
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value.toUpperCase())}
              placeholder={`Digita ${confirmWord}`}
              className="text-center font-mono tracking-wider"
              data-testid="confirm-delete-input"
              autoComplete="off"
            />
          </div>
          
          <div className="flex gap-3 pt-2">
            <Button 
              variant="outline" 
              className="flex-1"
              onClick={() => handleOpenChange(false)}
              disabled={loading}
            >
              Annulla
            </Button>
            <Button 
              variant="destructive"
              className="flex-1"
              onClick={handleConfirm}
              disabled={inputValue !== confirmWord || loading}
              data-testid="confirm-delete-btn"
            >
              {loading ? "Eliminazione..." : "Elimina Definitivamente"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
